import React from "react";

import Solution from "assets/img/Brands.png";
import SectionHeader from "components/common/section-header/section-header";

import "./info-section.styles.scss";
const InfoSection = () => {
  return (
    <div className="container">
      <div className="info-section">
        <div className="row">
          <div className="col-lg-6">
            <img src={Solution} alt="solution" />
          </div>
          <div className="col-lg-6 info-section_description">
            <SectionHeader
              main="We know our stuff!"
              headerText="Best in class service"
            />

            <p className="mt-5">
              This is the main factor that sets us apart from our competition
              and allows us to deliver a specialist business consultancy
              service. Our team applies its wide-ranging experience to
              determining. Through our years of experience, we&apos;ve also
              learned that while each channel. This is the main factor that sets
              us apart from our competition and allows us to deliver a
              specialist business consultancy service.
              <br />
              <br />
              This is the main factor that sets us apart from our competition
              and allows us to deliver a specialist business consultancy
              service. Our team applies its wide-ranging experience to
              determining. Through our years of experience, we&apos;ve also
              learned that while each channel. This is the main factor that sets
              us apart from our competition and allows us to deliver a
              specialist business consultancy service.
            </p>
          </div>
        </div>

        <div className="row info-section_roi">
          <div className="col-lg-6 info-section_description">
            <SectionHeader main="Our Values" headerText="Increasing Your ROI" />

            <p className="mt-5">
              This is the main factor that sets us apart from our competition
              and allows us to deliver a specialist business consultancy
              service. Our team applies its wide-ranging experience to
              determining. Through our years of experience, we&apos;ve also
              learned that while each channel. This is the main factor that sets
              us apart from our competition and allows us to deliver a
              specialist business consultancy service.
              <br />
              <br />
              This is the main factor that sets us apart from our competition
              and allows us to deliver a specialist business consultancy
              service. Our team applies its wide-ranging experience to
              determining. Through our years of experience, we&apos;ve also
              learned that while each channel. This is the main factor that sets
              us apart from our competition and allows us to deliver a
              specialist business consultancy service.
            </p>
          </div>
          <div className="col-lg-6">
            <img src={Solution} alt="solution" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoSection;
